import Constants from "../utils/consts";
import Utils from "../utils/utils";

var http = require("follow-redirects").https;
var fs = require("fs");
var qs = require("querystring");

export default async function createRichiestaRecuperoStudente(
  username,
  token,
  idStudente,
  idLezione,
  idSessione = null
) {
  console.log("[createRichiestaRecuperoStudente] Parametri ricevuti:", {
    username,
    idStudente,
    idLezione,
    idSessione,
  });

  return new Promise(function(resolve, reject) {
    var options = {
      method: "POST",
      hostname: Constants.ipAddress,
      path: Constants.apisFolder + "sendRichiestaRecupero.php",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Cookie: "uid=e02675a1a7516909792f6850dffcd5fe",
      },
      maxRedirects: 20,
    };

    var req = http.request(options, function(res) {
      var chunks = [];

      res.on("data", function(chunk) {
        chunks.push(chunk);
      });

      res.on("end", function(chunk) {
        var body = Buffer.concat(chunks);
        const bodyString = body.toString();
        console.log(
          "Raw response from createRichiestaRecuperoStudente:",
          bodyString
        );

        if (!bodyString.trim()) {
          console.error("Empty response from server");
          resolve({
            result: "error",
            message: "Server returned empty response",
          });
          return;
        }

        try {
          const resp = JSON.parse(bodyString);
          resolve(resp);
        } catch (parseError) {
          console.error("JSON parse error:", parseError);
          console.error("Response body:", bodyString);
          resolve({
            result: "error",
            message: "Invalid JSON response from server",
          });
        }
      });

      res.on("error", function(error) {
        console.error(error);
      });
    });

    var postData = qs.stringify({
      uname: username,
      token: token,
      user_id: 1, // ID del professore/admin che crea la richiesta
      title: "Richiesta di recupero",
      body: "Richiesta di recupero creata dal professore per la lezione",
      entity_name: "lezione",
      lezione_id: idLezione,
      id_studente: idStudente,
      id_sessione: idSessione, // Aggiungi id_sessione
      from_gestionale: 1, // Flag per indicare che la richiesta viene dal gestionale (richiesta_da_studente = 0)
    });

    console.log(
      "[createRichiestaRecuperoStudente] Dati POST inviati:",
      postData
    );

    req.write(postData);

    req.end();
  });
}
